import { Grid } from '@mui/material'
import { AuthLayout } from 'components'
import { WELCOME_DESCRIPTION, WELCOME_TITLE, WELCOME_SUB_DESCRIPTION } from 'config'
import { AuthMain, AuthWrapper } from '../SignIn'
import { Form } from './component'


export const SignUp: React.FC = () => {
  return (
    <AuthLayout
      title={WELCOME_TITLE}
      desc={WELCOME_DESCRIPTION}
      isAuthPage={true}
      subDesc={WELCOME_SUB_DESCRIPTION}
    >
      <AuthWrapper isAuthPage={true}>
        <Grid container justifyContent='center' mb="7vh">
          <Grid item xs={12} md={6}>
            <AuthMain isRounded={true}>
              <Form />
            </AuthMain>
          </Grid>
        </Grid>
      </AuthWrapper>
    </AuthLayout>
  )
}
